// oz-54
document.addEventListener('DOMContentLoaded', function() {
  (function() {
    console.log("movinnnnnnnnnnnnnnnnnnnnnnnnnnnnnng");
    
    function moveQuizLink() {
      if (window.innerWidth >= 768) return; 

      const quizLink = document.querySelector('a[href="#quiz-kit-key-uBjgb8J5H"]');
      if (!quizLink) return; 

      const quizItem = quizLink.parentElement;

      let target = 
        document.querySelector('.site-nav > .mega-menu:first-child .site-nav-dropdown .container.style_3') ||
        document.querySelector('.site-nav-dropdown .container.style_3') ||
        document.querySelector('.site-nav-dropdown .container') ||
        document.querySelector('.site-nav-dropdown');

      if (target && !target.dataset.quizMoved) { 
        target.prepend(quizItem.cloneNode(true));
        quizItem.remove();

        const movedLink = target.querySelector('a[href="#quiz-kit-key-uBjgb8J5H"]');
        if (movedLink) {
            movedLink.style.paddingLeft = '0';
        }
        target.dataset.quizMoved = 'true'; 
      }
    }

    moveQuizLink();

    const observer = new MutationObserver(() => {
      moveQuizLink();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', moveQuizLink);
  })();
});